import { useMemo } from 'react';

import { createDocumentUrlForTemplate } from '@modules/_shared/utils/document-url';
import type { Language } from '@shared/LocaleContext';

/**
 * Creates a stable docs URL for a template-backed document. A stable URL
 * instance keeps consumers such as tracked-link minting from resetting when
 * the underlying document inputs have not changed.
 */
export const useDocumentUrl = (
  templateId: string,
  documentId: string,
  language: Language,
): URL =>
  useMemo(
    () => createDocumentUrlForTemplate(templateId, documentId, language),
    [templateId, documentId, language],
  );
